/**
 * Initialize Swiper on a testimonials carousel root element.
 *
 * @param {HTMLElement} rootEl `.testimonials-swiper.swiper` element.
 * @return {import('swiper').Swiper|null}
 */
export function initTestimonialsSwiper( rootEl ) {
	if ( ! rootEl || typeof window.Swiper === 'undefined' ) {
		return null;
	}

	if ( rootEl.swiper && ! rootEl.swiper.destroyed ) {
		rootEl.swiper.destroy( true, true );
	}

	const wrap = rootEl.closest( '.testimonials-swiper-wrap' ) || rootEl.parentElement;
	const section = rootEl.closest( '.geocare-testimonials' );
	const navWrap = section?.querySelector( '.geocare-testimonials__nav' );
	const delay = parseInt( rootEl.dataset.autoplayDelay || '5000', 10 );
	const columns = parseInt( rootEl.dataset.columns || '3', 10 );
	const desktopSlides = columns === 2 ? 2 : 3;
	const slideCount = rootEl.querySelectorAll( '.swiper-slide' ).length;
	const canLoop = slideCount > desktopSlides;

	const swiper = new window.Swiper( rootEl, {
		loop: canLoop,
		speed: 700,
		slidesPerView: 1,
		spaceBetween: 20,
		watchOverflow: true,
		autoplay:
			delay > 0
				? {
						delay,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
				  }
				: false,
		pagination: {
			el: wrap?.querySelector( '.testimonials-swiper__pagination' ),
			clickable: true,
		},
		navigation: {
			nextEl: navWrap?.querySelector( '.testimonials-swiper__next' ),
			prevEl: navWrap?.querySelector( '.testimonials-swiper__prev' ),
		},
		breakpoints: {
			1024: {
				slidesPerView: desktopSlides,
				spaceBetween: 28,
			},
		},
	} );

	return swiper;
}

/**
 * Initialize every testimonials swiper on the page.
 */
export function initAllTestimonialsSwipers() {
	document
		.querySelectorAll( '.testimonials-swiper.swiper' )
		.forEach( ( el ) => initTestimonialsSwiper( el ) );
}
